export default "__VITE_ASSET__bfd07e51__"